<template>
  <div class="publicity">
    <div class="title">标前狗如何协助您业绩规模化增长？</div>
    <div class="title-text">
      专注招标采购领域三十余年，百万独家一手项目信息，结合大数据助力寻源
    </div>
    <div class="item m-t-64">
      <div class="item-img">
        <slider v-if="slider1 === 'slider1a'" ref="slider1a" :options="options">
          <slideritem
            v-for="(item, index) in banner1a"
            :key="index"
            :style="item.style"
          >
            <img style="width: 648px" :src="item.img" />
          </slideritem>
        </slider>
        <slider v-if="slider1 === 'slider1b'" ref="slider1b" :options="options">
          <slideritem
            v-for="(item, index) in banner1b"
            :key="index"
            :style="item.style"
          >
            <img style="width: 648px" :src="item.img" />
          </slideritem>
          <div slot="loading">loading...</div>
        </slider>
      </div>
      <div>
        <div class="item-operation right">
          <div class="operation-title">获取全国各行业招标采购商机</div>
          <div
            class="operation-content"
            :class="{ active: slider1 === 'slider1a' }"
            @mouseenter="mouseenter('slider1a', 0)"
          >
            <div class="operation-content-title">全国招标信息检索</div>
            <div class="operation-content-text">
              <i class="iconfont icon--_check text-icon m-r-5"></i>
              全国各行业千万级招标信息库，每日更新1万+，百万个采购单位库
            </div>
            <div class="operation-content-text m-t-12">
              <i class="iconfont icon--_check text-icon m-r-5"></i>
              独家一手项目信息，投标、交易一站式服务
            </div>
            <div class="operation-btn-box">
              <el-button type="primary" @click="handleVipBuy">
                点击购买
              </el-button>
              <el-button type="primary" plain @click="openForm">
                立即体验
              </el-button>
              <el-button
                plain
                class="more-btn"
                @click="goPage('ServiceIntroductionBigDataBusiness')"
              >
                了解更多
              </el-button>
            </div>
          </div>
          <div
            class="operation-content m-t-16"
            :class="{ active: slider1 === 'slider1b' }"
            @mouseenter="mouseenter('slider1b', 1)"
          >
            <div class="operation-content-title">项目信息精准推送</div>
            <div class="operation-content-text">
              <i class="iconfont icon--_check text-icon m-r-5"></i>
              支持按地区、行业、项目关键词定制招标信息推送，自动获取商机
            </div>
            <div class="operation-btn-box">
              <el-button type="primary" @click="handleVipBuy">
                点击购买
              </el-button>
              <el-button type="primary" plain @click="openForm">
                立即体验
              </el-button>
              <el-button
                plain
                class="more-btn"
                @click="goPage('ServiceIntroductionBigDataBusiness')"
              >
                了解更多
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="item m-t-100">
      <div>
        <div class="item-operation left">
          <div class="operation-title">大数据分析：全方位辅助投标决策</div>
          <div
            class="operation-content"
            :class="{ active: slider2 === 'slider2a' }"
            @mouseenter="mouseenter('slider2a', 0)"
          >
            <div class="operation-content-title">采购单位全方位分析</div>
            <div class="operation-content-text">
              <i class="iconfont icon--_check text-icon m-r-5"></i>
              大数据全景展示采购单位画像，提供历史采购记录及规模统计、深度解析采购需求
            </div>
            <div class="operation-content-text m-t-12">
              <i class="iconfont icon--_check text-icon m-r-5"></i>
              全面挖掘采购单位与合作供应商的关系
            </div>
            <div class="operation-btn-box">
              <el-button type="primary" @click="handleVipBuy">
                点击购买
              </el-button>
              <el-button type="primary" plain @click="openForm">
                立即体验
              </el-button>
              <el-button
                plain
                class="more-btn"
                @click="goPage('ServiceIntroductionCompetitiveness')"
              >
                了解更多
              </el-button>
            </div>
          </div>
          <div
            class="operation-content m-t-16"
            :class="{ active: slider2 === 'slider2b' }"
            @mouseenter="mouseenter('slider2b', 1)"
          >
            <div class="operation-content-title">竞争对手分析</div>
            <div class="operation-content-text">
              <i class="iconfont icon--_check text-icon m-r-5"></i>
              全面分析竞争对手实力
            </div>
            <div class="operation-btn-box">
              <el-button type="primary" @click="handleVipBuy">
                点击购买
              </el-button>
              <el-button type="primary" plain @click="openForm">
                立即体验
              </el-button>
              <el-button
                plain
                class="more-btn"
                @click="goPage('ServiceIntroductionCompetitiveness')"
              >
                了解更多
              </el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="item-img">
        <slider v-if="slider2 === 'slider2a'" ref="slider2" :options="options">
          <slideritem
            v-for="(item, index) in banner2a"
            :key="index"
            :style="item.style"
          >
            <img style="width: 648px" :src="item.img" />
          </slideritem>
        </slider>
        <slider v-if="slider2 === 'slider2b'" ref="slider2" :options="options">
          <slideritem
            v-for="(item, index) in banner2b"
            :key="index"
            :style="item.style"
          >
            <img style="width: 648px" :src="item.img" />
          </slideritem>
        </slider>
      </div>
    </div>
    <div class="item m-t-100">
      <div class="item-img">
        <slider v-if="slider3 === 'slider3a'" ref="slider3" :options="options">
          <slideritem
            v-for="(item, index) in banner3a"
            :key="index"
            :style="item.style"
          >
            <img style="width: 648px" :src="item.img" />
          </slideritem>
        </slider>
        <slider v-if="slider3 === 'slider3b'" ref="slider3" :options="options">
          <slideritem
            v-for="(item, index) in banner3b"
            :key="index"
            :style="item.style"
          >
            <img style="width: 648px" :src="item.img" />
          </slideritem>
        </slider>
      </div>
      <div>
        <div class="item-operation right">
          <div class="operation-title">
            监控助手：项目进度、企业/单位情报监控
          </div>
          <div
            class="operation-content"
            :class="{ active: slider3 === 'slider3a' }"
            @mouseenter="mouseenter('slider3a', 0)"
          >
            <div class="operation-content-title">项目进度监控</div>
            <div class="operation-content-text">
              <i class="iconfont icon--_check text-icon m-r-5"></i>
              通过微信/短信等及时反馈项目进度，随时把控招标采购需求变更，避免错过投标时机
            </div>
            <div class="operation-btn-box">
              <el-button type="primary" @click="handleVipBuy">
                点击购买
              </el-button>
              <el-button type="primary" plain @click="openForm">
                立即体验
              </el-button>
              <el-button
                plain
                class="more-btn"
                @click="goPage('ServiceIntroductionCompetitiveness')"
              >
                了解更多
              </el-button>
            </div>
          </div>
          <div
            class="operation-content m-t-16"
            :class="{ active: slider3 === 'slider3b' }"
            @mouseenter="mouseenter('slider3b', 1)"
          >
            <div class="operation-content-title">企业/单位情报监控</div>
            <div class="operation-content-text">
              <i class="iconfont icon--_check text-icon m-r-5"></i>
              大数据系统全方位、全天候监控竞争对手参与项目记录，采购单位发布项目动态，企业情报一手掌握
            </div>
            <div class="operation-btn-box">
              <el-button type="primary" @click="handleVipBuy">
                点击购买
              </el-button>
              <el-button type="primary" plain @click="openForm">
                立即体验
              </el-button>
              <el-button
                plain
                class="more-btn"
                @click="goPage('ServiceIntroductionCompetitiveness')"
              >
                了解更多
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <form-popup :visible.sync="formVisible" />
  </div>
</template>

<script>
import { slider, slideritem } from 'vue-concise-slider'
import { toVipBuy } from '@/utils/common'
import FormPopup from '@/components/common/FormPopup'

export default {
  name: 'GrowthPublicity',

  components: {
    slider,
    slideritem,
    FormPopup
  },

  data() {
    return {
      formVisible: false,
      banner1a: [
        {
          img: require('@/assets/images/home/img1.png'),
          style: {
            paddingBottom: '16px'
          }
        },
        {
          img: require('@/assets/images/home/img2.png'),
          style: {
            paddingBottom: '16px'
          }
        }
      ],
      banner1b: [
        {
          img: require('@/assets/images/home/img3.png'),
          style: {
            paddingBottom: '16px'
          }
        },
        {
          img: require('@/assets/images/home/img4.png'),
          style: {
            paddingBottom: '16px'
          }
        }
      ],
      banner2a: [
        {
          img: require('@/assets/images/home/img5.png'),
          style: {
            paddingBottom: '16px'
          }
        },
        {
          img: require('@/assets/images/home/img6.png'),
          style: {
            paddingBottom: '16px'
          }
        }
      ],
      banner2b: [
        {
          img: require('@/assets/images/home/img7.png'),
          style: {
            paddingBottom: '16px'
          }
        },
        {
          img: require('@/assets/images/home/img8.png'),
          style: {
            paddingBottom: '16px'
          }
        }
      ],
      banner3a: [
        {
          img: require('@/assets/images/home/img9.png'),
          style: {
            paddingBottom: '16px'
          }
        },
        {
          img: require('@/assets/images/home/img10.png'),
          style: {
            paddingBottom: '16px'
          }
        }
      ],
      banner3b: [
        {
          img: require('@/assets/images/home/img11.png'),
          style: {
            paddingBottom: '16px'
          }
        },
        {
          img: require('@/assets/images/home/img12.png'),
          style: {
            paddingBottom: '16px'
          }
        }
      ],
      options: {
        currentPage: 0, // 当前页码
        autoplay: 5000,
        loop: true, // 循环滚动
        slidesToScroll: 1, // 每次滑动项数
        timingFunction: 'ease', // 滑动方式
        speed: 300 // 滑动时间
      },
      slider1: 'slider1a',
      slider2: 'slider2a',
      slider3: 'slider3a'
    }
  },

  methods: {
    mouseenter(slider, imgIndex) {
      if (slider === 'slider1a') {
        this.slider1 = 'slider1a'
      }
      if (slider === 'slider1b') {
        this.slider1 = 'slider1b'
      }
      if (slider === 'slider2a') {
        this.slider2 = 'slider2a'
      }
      if (slider === 'slider2b') {
        this.slider2 = 'slider2b'
      }
      if (slider === 'slider3a') {
        this.slider3 = 'slider3a'
      }
      if (slider === 'slider3b') {
        this.slider3 = 'slider3b'
      }
    },

    handleVipBuy() {
      toVipBuy(this.$router)
    },
    openForm() {
      this.formVisible = true
    },
    goPage(name) {
      this.$router.push({
        name: name
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.publicity {
  width: 100%;
  height: 1856px;
  background: url('~@/assets/images/home/Publicity-bg.png') no-repeat;
  .title {
    display: flex;
    justify-content: center;
    font-size: 28px;
    font-weight: 400;
    padding-top: 48px;
  }
  .title-text {
    display: flex;
    justify-content: center;
    font-size: 14px;
    font-weight: 400;
    color: $text-second-color;
    margin-top: 16px;
  }
  .item {
    display: flex;
    justify-content: center;
    align-items: center;
    .item-img {
      width: 680px;
      height: 466px;
      background: $white-color;
      box-sizing: border-box;
      padding: 16px 16px 0 16px;
      border-radius: 10px;
      transition: all 0.8s;
      ::v-deep {
        .swiper-container-horizontal > .slider-pagination-bullets {
          bottom: 5px;
        }
        .slider-pagination-bullet {
          width: 16px;
          height: 3px;
          background: $info-color;
          border-radius: 2px;
        }
        .slider-pagination-bullet-active {
          width: 24px;
          height: 3px;
          background: $primary-color;
          border-radius: 2px;
        }
      }
    }
    .item-operation {
      width: 520px;
      background: #1d3f6e;
      box-sizing: border-box;
      padding: 24px;
      .operation-title {
        font-size: 22px;
        color: $white-color;
        font-weight: 500;
        margin-bottom: 24px;
      }
      .operation-content {
        box-sizing: border-box;
        padding: 24px 20px 24px 24px;
        background: rgba(245, 245, 245, 0.15);
        border-radius: 4px;
        cursor: pointer;
        transition: all 0.8s;
        .operation-content-title {
          font-size: 16px;
          color: $white-color;
          font-weight: 500;
          margin-bottom: 16px;
        }
        .operation-content-text {
          font-size: 14px;
          color: $white-color;
          font-weight: 400;
          display: flex;
          .text-icon {
            font-size: 20px;
            color: $white-color;
            margin-top: -2px;
          }
        }
        .operation-btn-box {
          display: none;
          margin-top: 24px;
        }
        &.active {
          background: $primary-third-color;
          .operation-content-title {
            color: $text-color;
          }
          .operation-content-text {
            color: $text-second-color;
            .text-icon {
              color: $primary-color;
            }
          }
          .operation-btn-box {
            display: flex;
            .more-btn {
              background: #d8ebff;
              border: 1px solid #bfbfbf;
            }
          }
        }
      }
    }
    .right {
      border-radius: 0px 10px 10px 0px;
    }
    .left {
      border-radius: 10px 0px 0px 10px;
    }
  }
}
</style>
